module.exports = __webpack_public_path__ + "img/dc.5662c6ff.svg";